export const isString = val => typeof val === 'string'
export const isObject = val => val !== null && typeof val === 'object'
export const isNullObject = val => Object.keys(val).length === 0
export const isArray = val =>
  Object.prototype.toString.call(val) === '[object Array]'
export const isDef = val => val !== undefined && val !== null
export const isUndef = val => val === undefined || val === null

/**
 * 通过路由path获取指定路由的完整url
 * @param {string} path 路由路径
 * @param {Object} params 参数
 * @return {string}
 */
export function getUrlByPath(path, params) {
  let baseUrl = `${location.origin}${process.env.BASE_URL}`
  const isStartWithSlash = path.indexOf('/') === 0

  if (/\/$/.test(baseUrl)) {
    if (isStartWithSlash) {
      baseUrl = baseUrl.replace(/\/$/, '')
    }
  } else if (!isStartWithSlash) {
    baseUrl += '/'
  }

  let url = baseUrl + path

  const urlParams = []

  if (params) {
    for (const key in params) {
      isDef(params[key]) && urlParams.push(`${key}=${params[key]}`)
    }

    url += `?${urlParams.join('&')}`
  }

  return url
}

/**
 * 修复ios设备上键盘的部分问题
 * 1. 键盘收起时，下方留白的问题
 * 2. 键盘被遮挡
 * @param {Element} [el]
 */
export function fixIosKeyboard(el) {
  const bodyElm = document.body

  // let scrollHeight = window.innerHeight

  // bodyElm.addEventListener('focusin', () => {
  //   console.info('focusin')
  //   clearTimeout(timer)
  //   timer = null
  //
  //   setTimeout(() => {
  //     window.scrollTo(0, scrollHeight)
  //   }, 50)
  // })

  bodyElm.addEventListener('focusout', () => {
    // 软键盘关闭事件, 修复键盘收起后键盘下方留白
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 200)
  })
}

/**
 * 修复安卓设备上收起键盘时未自动失去焦点的问题
 * @param {String|Array<String|Element>|Element} el 需要自动失去焦点的元素
 */
export function fixAndroidKeyboardAutoBlur(el) {
  const clientHeight =
    document.documentElement.clientHeight || document.body.clientHeight

  const _blur = _el => {
    if (isString(_el)) {
      document.querySelector(_el).blur()
    } else {
      _el.blur()
    }
  }

  // 监听安卓键盘收起事件
  window.onresize = () => {
    const resizeHeight =
      document.documentElement.clientHeight || document.body.clientHeight
    // 防止用户点击键盘中的收起按钮，输入框未失去焦点的问题
    if (resizeHeight === clientHeight) {
      if (isArray(el)) {
        el.forEach(_blur)
      } else {
        _blur(el)
      }
    }
  }
}

/**
 * 数值转换
 */
export function toThousands(a) {
  // return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  var xiaoshu = '' // 用来记录参数小数数值包括小数点
  var zhengshu = '' // 用来记录参数录整数数值
  if (a < 1000) {
    // 当参数小于1000的时候直接返回参数
    return a
  } else {
    const t = a.toString() // 将整数转换成字符串
    if (t.indexOf('.') > 0) {
      // 如果参数存在小数，则记录小数部分与整数部分
      var index = t.indexOf('.')
      xiaoshu = t.slice(index, t.length)
      zhengshu = t.slice(0, index)
    } else {
      // 否则整数部分的值就等于参数的字符类型
      zhengshu = t
    }
    var num = parseInt(zhengshu.length / 3) // 判断需要插入千位分割符的个数

    // 将整数1234567890部分拆分为2部分，变量head:1   变量body:123456789
    var head = zhengshu.slice(0, zhengshu.length - num * 3)
    if (head.length > 0) {
      // 如果head存在，则在head后面加个千位分隔符，
      head += ','
    }
    var body = zhengshu.slice(zhengshu.length - num * 3, zhengshu.length)

    // 将body字符串123456789转换成一个字符数组arr2 = ['123','456','789']
    var arr2 = []
    for (var i = 0; i < num; i++) {
      arr2.push(body.slice(i * 3, i * 3 + 3))
    }
    body = arr2.join(',') // 将数组arr2通过join(',')   方法，拼接成一个以逗号为间隔的字符串

    zhengshu = head + body // 拼接整数部分
    var result = zhengshu + xiaoshu // 最后拼接整数和小数部分
    return result // 返回结果
  }
}

export function getRequestParam(param) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === param) {
      return pair[1]
    }
  }
  return false
}
